<template>
  <div class="row mb-2">
    <div class="col-md-6">
      <div
        class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative"
      >
        <div class="col p-4 d-flex flex-column position-static">
          <h3 class="mb-4">Zmiana hasła</h3>
          <b-alert v-show="success" variant="success" show>Hasło zostało zmienione</b-alert>
          <b-alert v-show="error" variant="danger" show
            >Podane obecne hasło nie jest prawidłowe</b-alert
          >
          <b-form @submit.prevent="submit">
            <b-form-group label="Obecne hasło:" label-for="current-password">
              <b-form-input
                id="current-password"
                v-model="credentials.currentPassword"
                type="password"
                required
                placeholder="Wpisz obecne hasło"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Nowe hasło:" label-for="new-password">
              <b-form-input
                id="new-password"
                v-model="credentials.newPassword"
                type="password"
                required
                placeholder="Wpisz nowe hasło"
              ></b-form-input>
              <password v-model="credentials.newPassword" :strength-meter-only="true"></password>
            </b-form-group>
            <b-form-group label="Powtórzenie nowego hasła:" label-for="new-password-repeat">
              <b-form-input
                id="new-password-repeat"
                v-model="newPasswordRepeat"
                type="password"
                required
                placeholder="Wpisz ponownie nowe hasło"
              ></b-form-input>
              <small
                v-show="credentials.newPassword !== newPasswordRepeat"
                tabindex="-1"
                class="form-text text-danger"
                >Podane hasła nie są takie same.</small
              >
            </b-form-group>
            <b-button type="submit" variant="primary" class="float-right">Zmień</b-button>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter'

export default {
  data() {
    return {
      credentials: {
        currentPassword: '',
        newPassword: ''
      },
      newPasswordRepeat: '',
      error: false,
      success: false
    }
  },
  methods: {
    submit() {
      const vm = this
      if (vm.credentials.newPassword !== vm.newPasswordRepeat) return
      vm.error = false
      vm.success = false
      vm.$store.commit('addPageLoaderEvent', 'login')
      vm.$http
        .post('auth/change-password', vm.credentials)
        .then(
          success => {
            vm.success = true
          },
          error => {
            vm.error = true
          }
        )
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'login')
        })
    }
  },
  components: {
    Password
  }
}
</script>

<style lang="scss" scoped>
.Password {
  max-width: none;
}
</style>
